import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

export const ASSETS_URL_REGEX = /assets\//;
export const RESOURCES_URL_REGEX = /resources\//;

export abstract class StaticInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;
    if (req.url.match(ASSETS_URL_REGEX) || req.url.match(RESOURCES_URL_REGEX)) {
      return this.internalIntercept(req, next);
    }
    return next.handle(request);
  }

  protected abstract internalIntercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>;

}
